<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='专辑列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="2" v-if="rights.canAdd==1">
          <el-button type="primary" @click="showAddDialog">添加专辑</el-button>
        </el-col>
        <el-col :span="4">
          <el-select v-model="param.group_id" placeholder="请选择栏目" filterable>
            <el-option label="请选择栏目" value="0"></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="param.speaker_id" placeholder="请选择讲员" filterable>
            <el-option label="请选择讲员" :value="0"></el-option>
            <el-option v-for="item in speakerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col v-if="rights.canPublish==1" :span="4">
          <el-select v-model="param.creator_id" placeholder="请选择上传用户" filterable>
            <el-option label="请选择上传用户" :value="0"></el-option>
            <el-option v-for="item in adminList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-col>
        <el-col v-if="rights.canPublish==1" :span="3">
          <el-select v-model="param.is_recommend" placeholder="是否推荐" filterable>
            <el-option label="全部" value="0"></el-option>
            <el-option label="不推荐" value="1"></el-option>
            <el-option label="推荐" value="2"></el-option>
          </el-select>
        </el-col>
        <el-col v-if="rights.canPublish==1" :span="3">
          <el-select v-model="param.is_publish" placeholder="是否发布" filterable>
            <el-option label="全部" value="0"></el-option>
            <el-option label="未发布" value="1"></el-option>
            <el-option label="已发布" value="2"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-input placeholder="请输入专辑名称" v-model="param.keywords" clearable @clear="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
        <el-col v-if="rights.canDownload==1" :span="2">
          <a href="/proxy/admin/download/category_list"><el-button type="primary">导出列表</el-button></a>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="categoryList" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="50px"></el-table-column>
      <el-table-column v-if="rights.canLink==1" label="名称" align="center">
        <template slot-scope="scope">
          <a :href="scope.row.url" target="_blank">{{scope.row.name}}</a>
        </template>
      </el-table-column>
      <el-table-column v-else prop="name" label="名称" align="center"></el-table-column>
      <el-table-column prop="pic" label="封面图" align="center">
        <template slot-scope="scope">
          <el-image :src="scope.row.pic+'?imageView2/0/w/50'" class="list_img"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="group_name" label="栏目" align="center"></el-table-column>
      <el-table-column prop="speaker_name" label="讲员" align="center"></el-table-column>
      <el-table-column v-if="rights.canPublish==1" prop="play_times" label="播放次数" align="center"></el-table-column>
      <el-table-column v-if="rights.canPublish==1" prop="content_num" label="视频数量" align="center"></el-table-column>
      <el-table-column label="是否推荐" align="center">
        <template slot-scope="scope">
          <el-switch :value="scope.row.is_speaker_hot==1"></el-switch>
        </template>
      </el-table-column>
      <el-table-column label="是否发布" align="center">
        <template slot-scope="scope">
          <el-switch :value="scope.row.publish_status==2"></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="creator_name" label="上传用户" align="center"></el-table-column>
      <el-table-column label="创建时间" align="center">
        <template slot-scope="scope">
          {{scope.row.create_time | dateTimeFormat}}
        </template>
      </el-table-column>
      <el-table-column v-if="rights.canUpdate==1 || rights.canDelete==1 || rights.canPublish==1" label="操作" align="center" width="290px">
        <template slot-scope="scope">
          <el-button v-if="rights.canUpdate==1" type="primary" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button v-if="rights.canDelete==1" type="danger" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
          <el-button v-if="scope.row.publish_status==1 && rights.canPublish==1" type="success" size="mini" @click="publish(scope.row.id)">发布</el-button>
          <el-button v-if="scope.row.publish_status==2 && rights.canPublish==1" type="warning" size="mini" @click="unPublish(scope.row.id)">取消</el-button>
          <el-button v-if="scope.row.is_speaker_hot==0 && rights.canRecommend==1" type="success" size="mini" @click="recommend(scope.row.id)">推荐</el-button>
          <el-button v-if="scope.row.is_speaker_hot==1 && rights.canRecommend==1" type="warning" size="mini" @click="unRecommend(scope.row.id)">不推荐</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <category-add :visible="addDialogAvaible"
      :id="currentId"
      :groupList="groupList"
      :speakerList="speakerList"
      @add="addCategory"
      @update="updateCategory"
      @close="closeAddDialog">
    </category-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import CategoryAdd from './CategoryAdd.vue'
export default {
  name: 'category_list',
  components: {
    'bread-crumb': BreadCrumb,
    'category-add': CategoryAdd
  },
  data () {
    return {
      groupList: [],
      speakerList: [],
      adminList: [],
      speakerParam: {
        keywords: '',
        page: 1,
        count: 10
      },
      rights: {
        canAdd: 0,
        canUpdate: 0,
        canDelete: 0,
        canPublish: 0,
        canRecommend: 0,
        canDownload: 0,
        canLink: 0
      },
      categoryList: [],
      currentId: 0,
      total: 0,
      pageTotal: 1,
      param: {
        group_id: '',
        speaker_id: '',
        creator_id: '',
        is_recommend: '',
        is_publish: '',
        keywords: '',
        page: 1,
        count: 10
      },
      addDialogAvaible: false
    }
  },
  created () {
    this.getGroupList()
    this.getSpeakerList()
    this.getAdminList()
    this.getCategoryList()
    const rights = window.sessionStorage.getItem('rights')
    if (rights.indexOf('26') !== -1) {
      this.rights.canAdd = 1
    }
    if (rights.indexOf('27') !== -1) {
      this.rights.canUpdate = 1
    }
    if (rights.indexOf('28') !== -1) {
      this.rights.canDelete = 1
    }
    if (rights.indexOf('29') !== -1) {
      this.rights.canPublish = 1
    }
    if (rights.indexOf('36') !== -1) {
      this.rights.canDownload = 1
    }
    if (rights.indexOf('41') !== -1) {
      this.rights.canRecommend = 1
    }
    if (rights.indexOf('48') !== -1) {
      this.rights.canLink = 1
    }
  },
  methods: {
    async getCategoryList () {
      const res = await this.$http.get('/admin/category/list', this.param)
      if (res.code === 0) {
        this.categoryList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    async getGroupList () {
      const res = await this.$http.get('/admin/category/group/select_list')
      if (res.code === 0) {
        this.groupList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getSpeakerList (keywords) {
      this.speakerParam.keywords = keywords
      const res = await this.$http.get('/admin/speaker/select_list', this.speakerParam)
      if (res.code === 0) {
        this.speakerList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getAdminList () {
      const res = await this.$http.get('/admin/select_list')
      if (res.code === 0) {
        this.adminList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    search () {
      this.param.page = 1
      this.getCategoryList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getCategoryList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getCategoryList()
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/category/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getCategoryList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    async addCategory (data) {
      const res = await this.$http.post('/admin/category/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getCategoryList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async updateCategory (id, data) {
      const res = await this.$http.post('/admin/category/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getCategoryList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async publish (id) {
      const res = await this.$http.post('/admin/category/publish/' + id)
      if (res.code === 0) {
        this.$message.success('发布成功')
        this.getCategoryList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async unPublish (id) {
      const res = await this.$http.post('/admin/category/un_publish/' + id)
      if (res.code === 0) {
        this.$message.success('取消成功')
        this.getCategoryList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async recommend (id) {
      const res = await this.$http.post('/admin/category/recommend/' + id)
      if (res.code === 0) {
        this.$message.success('推荐成功')
        this.getCategoryList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async unRecommend (id) {
      const res = await this.$http.post('/admin/category/un_recommend/' + id)
      if (res.code === 0) {
        this.$message.success('取消推荐成功')
        this.getCategoryList()
      } else {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style scoped>
</style>
